import { Pipe, PipeTransform } from '@angular/core';
import {CampagneProduct} from "../models/Campagne/CampagneProduct";

@Pipe({
  name: 'setMaxCart',
  standalone: true
})
export class SetMaxCartPipe implements PipeTransform {

  transform(value: CampagneProduct): number | undefined {
    if (value.open || value.openQteLimit || value.quota)
      return undefined;

    return value.stockCommercial;
  }
}
